import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Injectable } from '@tanbo/vue-di-plugin'
import { TableMemoryPagination } from '@/services/table-memory-pagination'
import { ParamsClean } from '@/common/decorators/params-clean'
export interface QueryParams {
  end_time?: string
  limit: number
  page: number
  soft_group_id?: number
  soft_name?: string
  start_time?: string
  /** 排序字段 */
  sort?: string
  /** 顺序 */
  asc?: boolean
  device_id: string
  /** 是否使用内存数据 */
  useMemory: boolean
}

export interface SoftwareInfo {
  /** logo */
  logo_url: string
  /** 软件名称 */
  soft_name: string
  /** 日均使用次数 */
  use_soft_count: number
  /** 日均使用时长（分钟） */
  duration: number
  /** 使用终端数 */
  terminal_count: number
  /** 软件hash key */
  soft_hash_key: string
  /** 软件id */
  soft_id: number
  /** 软件版本 */
  soft_version: string
  /** 安装时间 */
  install_time: string
  /** 最后活跃时间 */
  last_active_time?: string | number
}

export interface SoftwareUninstallParams {
  uninstall_type: 0 | 1 // 0 提醒卸载， 1 启动卸载
  device_id: string
  soft_hash_keys: string []
}

@Injectable()
export class InstalledDetailService extends TableMemoryPagination<QueryParams, SoftwareInfo> {
  constructor (private http: Http) {
    super()
  }

  isEqual (el1: SoftwareInfo, el2: SoftwareInfo) {
    return el1.soft_id === el2.soft_id
  }

  @ParamsClean()
  @InvokeThrottle()
  getListByServer (params: Partial<QueryParams>) {
    return this.http.post<{
      total: number
      list: Record<string, unknown>[]
    }>('/softmgr/userecord/terminal-soft-list', params).then((res) => ({
      total: res.total ?? 0,
      list: (res.list || []).map((raw) => this.mapTerminalSoftRow(raw)),
    }))
  }

  private mapTerminalSoftRow (raw: Record<string, unknown>): SoftwareInfo {
    const avgUse = (raw.avg_use_count ?? raw.use_soft_count) as number | undefined
    const avgDur = (raw.avg_duration ?? raw.duration) as number | undefined
    const lastTs = raw.last_active_time
    const installRaw = raw.install_time
    return {
      logo_url: String(raw.logo_url ?? ''),
      soft_name: String(raw.soft_name ?? ''),
      use_soft_count: Number(avgUse ?? 0),
      duration: Number(avgDur ?? 0),
      terminal_count: Number(raw.terminal_count ?? 0),
      soft_hash_key: String(raw.soft_hash_key ?? ''),
      soft_id: Number(raw.soft_id ?? 0),
      soft_version: String(raw.soft_version ?? ''),
      install_time: installRaw != null ? String(installRaw) : '',
      last_active_time: lastTs as string | number | undefined,
    }
  }

  download (type: 0|1, options: QueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/userecord/terminal-soft-export', params, moduleName)
  }

  uninstallSoftware (params: SoftwareUninstallParams) {
    return this.http.post('/terminal-order/terminal-uninstall-soft', params)
  }
}
